import "./Library.css";
import React, { Component } from "react";
import {
  Button,
  PageHeader,
  ListGroup,
  ControlLabel,
  Glyphicon,
  FormControl,
  Thumbnail
} from "react-bootstrap";
import { API, Auth } from "aws-amplify";
import LibraryBookItem from "../components/LibraryBookItem";

import Rater from "react-rater";
import Modal from "react-modal";

export default class Library extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      books: null,
      openModal: false,
      bookDetails: null,
      bookScore: 0,
      bookComment: null
    };

    this.openBookPopup = this.openBookPopup.bind(this);
    this.closeBookPopup = this.closeBookPopup.bind(this);
    this.reviewCommentChange = this.reviewCommentChange.bind(this);
    this.reviewScoreChange = this.reviewScoreChange.bind(this);
    this.saveReview = this.saveReview.bind(this);
  }

  async componentDidMount() {
    console.log("Authenticated:", this.props.isAuthenticated);
    if (!this.props.isAuthenticated) {
      this.props.history.push("/login");
    }

    try {
      var books;
      var cacheBooks = localStorage.getItem("personalLibrary");

      if (cacheBooks) {
        books = JSON.parse(cacheBooks);
        console.log("Books from cache", books);
      } else
        books = await API.get("books", "user/books").catch(error => {
          console.log("API Error testing:", error);
          if (error === "No credentials") {
            console.log("No Credentials error.");
            Auth.signOut();
            this.props.userHasAuthenticated(false);
            this.props.history.push("/login");
            return;
          } else {
            return;
          }
        }); //this.GetUserBooks();
      if (books) {
        console.log("Searched books:", books);

        for (var i = 0; i < books.Count; i++) {
          console.log("Found Book, setting info:" + books.Items[i].ISBN);
          //books.Items[i].Info = await this.bookSearch(books.Items[i].ISBN);
        }
        this.setState({ books: books });
      }
    } catch (e) {
      alert(e);
    }

    this.setState({ isLoading: false });
  }

  GetUserBooks = () => {
    console.log("Obtaining books.");
    var result = API.get("books", "user/books");
    console.log("Books returned:", result);
    if (result === "No credentials.") this.props.history.push("/login");
    return result;
  };

  bookSearch(ISBN) {
    var info = "test"; //API.get("books", "search", {'ISBN': ISBN});

    return info;
  }
  saveReview = function() {
    console.log("saveReview: ");
    var comment = this.state.bookComment;
    var score = this.state.bookScore;
    var isbn = this.state.bookDetails.ISBN;
    var response = API.post("books", "user/review", {
      body: { ISBN: isbn, Review: { Score: score, Comment: comment } }
    });
    console.log("saveReview response: ", response);
    return false;
  };
  openBookPopup(book) {
    console.log("Popup Book: ", book);
    this.setState({ bookScore: book.Review ? book.Review.Score : 0 });
    this.setState({ bookComment: book.Review ? book.Review.Comment : "" });
    this.setState({ bookDetails: book });
    this.setState({ openModal: true });
  }
  reviewScoreChange(score) {
    console.log("reviewScoreChange: ", score.rating);
    this.setState({ bookScore: score.rating });
  }
  reviewCommentChange(event) {
    this.setState({ bookComment: event.target.value });
  }
  closeBookPopup() {
    console.log("closeBookPopup", this.state.openModal);

    this.setState({ openModal: false });

    console.log("openModal", this.state.openModal);
    return true;
  }

  showBookRequests = function(data) {
    console.log("Request Book: ", data);
    console.log("Request Total: ", data.length);
    console.log("Request Total2: ", Object.keys(data).length);
    //var response = API.post("books", "user/book", {body : {'ISBN': data.volumeInfo.industryIdentifiers[0].identifier,'Info': data}});
    //console.log('response: ', response);
    return false;
  };

  renderBooksList() {
    console.log("renderBooksList Start");
    if (!this.state.books) return;
    let books = this.state.books.Items;
    console.log("renderBooksList Books:", books);
    return [{}].concat(books).map((book, i) =>
      i !== 0 ? (
        <LibraryBookItem
          key={i}
          src={book}
          onClick={() => {
            this.openBookPopup(book);
          }}
        />
      ) : (
        ""
      )
    );
  }

  handleBookClick = event => {
    event.preventDefault();
    console.log("handleBookClick: ", event.currentTarget);

    this.props.history.push(
      "/user/books/" + event.currentTarget.getAttribute("src")
    );
  };

  renderLander() {
    return (
      <div className="lander">
        <h1>Bukhu</h1>
        <p>Share Your Treasure</p>
      </div>
    );
  }

  renderBooks() {
    return (
      <div className="books">
        <PageHeader>
          {this.state.isLoading && (
            <Glyphicon glyph="refresh" className="spinning" />
          )}
          Your Books
        </PageHeader>

        {this.state.isLoading ? (
          <ControlLabel key="0">Loading</ControlLabel>
        ) : this.state.books ? (
          this.state.books.Items.length > 0 ? (
            <Button
              key="addnew"
              href="/library/add"
              bsSize="sm"
              className="bf"
              bsStyle="primary"
            >
              <b>{"\uFF0B"}</b> Add a new book
            </Button>
          ) : (
            ""
          )
        ) : (
          <ControlLabel key="0">Your Library is empty</ControlLabel>
        )}
        <ListGroup>{!this.state.isLoading && this.renderBooksList()}</ListGroup>
        <Button
          key="new"
          href="/library/add"
          bsSize="sm"
          className=""
          bsStyle="primary"
        >
          <b>{"\uFF0B"}</b> Add a new book
        </Button>
        <Modal
          isOpen={this.state.openModal}
          //onAfterOpen={this.afterOpenModal}
          onRequestClose={() => {
            this.closeBookPopup();
          }}
          shouldCloseOnOverlayClick={false}
          className="Modal text-primary list-group-item"
          contentLabel="Book Details"
        >
          <Glyphicon
            glyph="remove-circle"
            className="btn btn-lg pull-right floating"
            onClick={this.closeBookPopup}
          />
          {this.state.bookDetails != null ? (
            <span>
              <h3>{this.state.bookDetails.Info.volumeInfo.title}</h3>

              {this.state.bookDetails.Info.volumeInfo ? (
                <div className="bookDetails">
                  {this.state.bookDetails.Info.volumeInfo.authors ? (
                    this.state.bookDetails.Info.volumeInfo.authors.map(
                      (auth, a) => {
                        return <span key={a}>{auth} - </span>;
                      }
                    )
                  ) : (
                    <span>Author unknown</span>
                  )}

                  <Thumbnail
                    src={
                      this.state.bookDetails.Info.volumeInfo &&
                      this.state.bookDetails.Info.volumeInfo.imageLinks
                        ? this.state.bookDetails.Info.volumeInfo.imageLinks
                            .smallThumbnail || "/img/nocover.png"
                        : "/img/nocover.png"
                    }
                    alt={this.state.bookDetails.Title}
                    className="img-rounded img-responsive pull-left"
                  >
                    <Rater
                      rating={this.state.bookScore}
                      interactive={true}
                      onRate={this.reviewScoreChange}
                    />
                  </Thumbnail>

                  {this.state.bookDetails.Info ? (
                    this.state.bookDetails.Info.volumeInfo ? (
                      <h5>{this.state.bookDetails.Info.volumeInfo.subtitle}</h5>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {this.state.bookDetails.Info
                    ? this.state.bookDetails.Info.volumeInfo
                      ? this.state.bookDetails.Info.volumeInfo.description
                      : "No Description Available"
                    : "No Description Available"}
                </div>
              ) : (
                "Book Information Not Available"
              )}
              <div className="bookfooter pull-right">
                {this.state.addMessage}
              </div>
              <div className="rating">
                <FormControl
                  componentClass="textarea"
                  placeholder="Review Comment"
                  value={this.state.bookComment}
                  onChange={this.reviewCommentChange}
                />
                <Button
                  className="pull-right floating"
                  bsStyle="primary"
                  onClick={this.saveReview}
                >
                  <Glyphicon glyph="save" /> Save Review
                </Button>
              </div>
            </span>
          ) : (
            "Book Information Not Available"
          )}
        </Modal>
      </div>
    );
  }

  render() {
    return (
      <div className="Library">
        {this.props.isAuthenticated ? this.renderBooks() : this.renderLander()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Library.js